module.exports = __webpack_public_path__ + "img/ch31.af19f1d2.png";